export interface ThemeColors {
  bg: string
  panel: string
  border: string
  teal: string
  tealdim: string
  text: string
  muted: string
  accent: string
  glow: string
  bgGradient: string
}

export interface Theme {
  id: string
  name: string
  era: string
  colors: ThemeColors
}

export const THEMES: Theme[] = [
  {
    id: 'ink',
    name: 'The Inkling',
    era: 'Candlelit desk',
    colors: {
      bg: '#f4f6f8',
      panel: '#ffffff',
      border: '#d4dbe4',
      teal: '#4a7cbb',
      tealdim: '#3b6a9e',
      text: '#1e2d3d',
      muted: '#7a8fa0',
      accent: '#4a7cbb',
      glow: 'rgba(74, 124, 187, 0.25)',
      bgGradient: 'radial-gradient(1200px 600px at 50% -10%, rgba(74, 124, 187, 0.06), transparent 60%)',
    },
  },
  {
    id: 'press',
    name: 'The Press',
    era: 'Gutenberg era',
    colors: {
      bg: '#1a1410',
      panel: '#211a14',
      border: '#3d2e1e',
      teal: '#d4a054',
      tealdim: '#a07830',
      text: '#e8dcc8',
      muted: '#8a7a62',
      accent: '#d4a054',
      glow: 'rgba(212, 160, 84, 0.35)',
      bgGradient: 'radial-gradient(1200px 600px at 50% -10%, rgba(212, 160, 84, 0.06), transparent 60%)',
    },
  },
  {
    id: 'library',
    name: 'The Library',
    era: 'Grand library',
    colors: {
      bg: '#0a120e',
      panel: '#0f1a14',
      border: '#1a3020',
      teal: '#4ade80',
      tealdim: '#22863a',
      text: '#d4e8d8',
      muted: '#6b8a72',
      accent: '#fbbf24',
      glow: 'rgba(74, 222, 128, 0.3)',
      bgGradient: 'radial-gradient(1200px 600px at 50% -10%, rgba(74, 222, 128, 0.06), transparent 60%)',
    },
  },
  {
    id: 'marble',
    name: 'The Academy',
    era: 'Marble halls',
    colors: {
      bg: '#111318',
      panel: '#181b22',
      border: '#2a2e38',
      teal: '#93c5fd',
      tealdim: '#60a5fa',
      text: '#e2e8f0',
      muted: '#7a8290',
      accent: '#c084fc',
      glow: 'rgba(147, 197, 253, 0.3)',
      bgGradient: 'radial-gradient(1200px 600px at 50% -10%, rgba(147, 197, 253, 0.06), transparent 60%)',
    },
  },
  {
    id: 'terminal',
    name: 'The Terminal',
    era: 'Digital age',
    colors: {
      bg: '#0a0a0a',
      panel: '#111111',
      border: '#1a1a1a',
      teal: '#00ff41',
      tealdim: '#00cc33',
      text: '#00ff41',
      muted: '#006622',
      accent: '#00ff41',
      glow: 'rgba(0, 255, 65, 0.3)',
      bgGradient: 'radial-gradient(1200px 600px at 50% -10%, rgba(0, 255, 65, 0.04), transparent 60%)',
    },
  },
  {
    id: 'wireframe',
    name: 'The Void',
    era: 'Abstract space',
    colors: {
      bg: '#000000',
      panel: '#0a0a0a',
      border: '#1a1a2e',
      teal: '#00d4ff',
      tealdim: '#0099cc',
      text: '#e0e0ff',
      muted: '#4a4a6a',
      accent: '#ff00ff',
      glow: 'rgba(0, 212, 255, 0.3)',
      bgGradient: 'radial-gradient(1200px 600px at 50% -10%, rgba(0, 212, 255, 0.04), transparent 60%)',
    },
  },
]

export function getThemeForEdition(edition: number): Theme {
  if (edition <= 1) return THEMES[0]  // ink
  if (edition <= 3) return THEMES[1]  // press
  if (edition <= 4) return THEMES[2]  // library
  if (edition <= 6) return THEMES[3]  // marble
  if (edition <= 8) return THEMES[4]  // terminal
  return THEMES[5]                     // wireframe
}
